import { AppPermissionInfo } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc';
import { PermissionType } from '../../types/dataPermissions';

export function isPermissionDisabled(
  permissionType: PermissionType,
  permission: AppPermissionInfo
): boolean {
  return permissionType === 'conditionallyRequired' && permission.isOnInstalls;
}
